import { Action } from '@ngrx/store';
import { label } from '../util';
import { GuestInformationPayload } from '../models/action-payloads/save-guest-information';
import { IGuestInformationSavePayload } from '../models/action-payloads/create-update-guest-information-payload';
import { PassengerCruiseSurvey } from '../models/cruise-survey';

export const GuestDetailsActionTypes = {
	SET_CURRENT_GUEST_ID: label('[GUESTDETAILS] Set current guest id'),
	SET_LOAD_BEGIN_DETAILS: label('[GUESTDETAILS] Set guests details'),
	LOAD_BEGIN_DETAILS: label('[GUESTDETAILS] Get guests details'),
	LOAD_BEGIN_DETAILS_SUCCESS: label('[GUESTDETAILS] Get guests details success'),
  SAVE_GUEST_DETAILS_SUCCESS: label('[GUESTDETAILS] Save guest details success'),
	LOAD_GUEST_DOCUMENT_TYPES: label('[GUESTDETAILS] Load Document types'),
	LOAD_GUEST_DOCUMENT_TYPES_SUCCESS: label('[GUESTDETAILS] Load Document types success'),
	SAVE_GUEST_SURVEY: label('[GUESTDETAILS] Save guest survey'),
	SAVE_GUEST_SURVEY_SUCCESS: label('[GUESTDETAILS] Save guest survey success'),

  // Cruise Survey
  POST_RETRIEVE_CRUISE_SURVEY_SUCCESS: label('[GUESTDETAILS] Post Retrieve Cruise Survey Success'),
  POST_RETRIEVE_CRUISE_SURVEY_FAILURE: label('[GUESTDETAILS] Post Retrieve Cruise Survey Error'),
  POST_SAVE_CRUISE_SURVEY_SUCCESS: label('[GUESTDETAILS] Post Save Cruise Survey Success'),
  POST_SAVE_CRUISE_SURVEY_FAILURE: label('[GUESTDETAILS] Post Save Cruise Survey Error'),
};

export class SetCurrentGuestIdAction implements Action {
	type = GuestDetailsActionTypes.SET_CURRENT_GUEST_ID;
	constructor(public payload: number | null) {}
}

export class SetLoadBeginDetailsAction implements Action {
	type = GuestDetailsActionTypes.SET_LOAD_BEGIN_DETAILS;
}

export class LoadBeginDetailsAction implements Action {
	type = GuestDetailsActionTypes.LOAD_BEGIN_DETAILS;
	constructor(public payload: any) {}
}

export class LoadBeginDetailsSuccessAction implements Action {
	type = GuestDetailsActionTypes.LOAD_BEGIN_DETAILS_SUCCESS;
	constructor(public payload: any) {}
}

export class SaveGuestDetailsSuccessAction implements Action {
	type = GuestDetailsActionTypes.SAVE_GUEST_DETAILS_SUCCESS;
	constructor(public payload: GuestInformationPayload<IGuestInformationSavePayload>) {}
}

export class LoadGuestDocumentTypesAction implements Action {
	type = GuestDetailsActionTypes.LOAD_GUEST_DOCUMENT_TYPES;
	constructor(public payload: any) {}
}

export class LoadGuestDocumentTypesSuccessAction implements Action {
	type = GuestDetailsActionTypes.LOAD_GUEST_DOCUMENT_TYPES_SUCCESS;
	constructor(public payload: any) {}
}

export class SaveGuestSurveyAction implements Action {
	type = GuestDetailsActionTypes.SAVE_GUEST_SURVEY;
	constructor(public payload: any) {}
}

export class SaveGuestSurveySuccessAction implements Action {
	type = GuestDetailsActionTypes.SAVE_GUEST_SURVEY_SUCCESS;
	constructor(public payload: any) {}
}

export class PostRetrieveCruiseSurveySuccess implements Action {
  type = GuestDetailsActionTypes.POST_RETRIEVE_CRUISE_SURVEY_SUCCESS;
  constructor(public payload: PassengerCruiseSurvey[]) { }
}

export class PostRetrieveCruiseSurveyFailure implements Action {
  type = GuestDetailsActionTypes.POST_RETRIEVE_CRUISE_SURVEY_FAILURE;
  constructor(public payload: any) { }
}

export class PostSaveCruiseSurveySuccess implements Action {
  type = GuestDetailsActionTypes.POST_SAVE_CRUISE_SURVEY_SUCCESS;
}

export class PostSaveCruiseSurveyFailure implements Action {
  type = GuestDetailsActionTypes.POST_SAVE_CRUISE_SURVEY_FAILURE;
}
